<template>
  <div style="word-break: break-word; position: relative">
    <div style="position: absolute; right: 1px; top: 1px">
      <v-btn @click="close" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <div>
      <v-layout row wrap>
        <v-flex sm4>
          <div style="padding: 23px">
            <v-img
              style="border-radius: 10px"
              :src="user.photourl ? user.photourl : '/static/img/empty-img-placeholder.png'"
            ></v-img>
          </div>
        </v-flex>
        <v-flex sm8>
          <div style="padding: 23px">
            <div class="caption">ชื่อ</div>
            <div style="font-weight: bold">{{ user.realname ? user.realname : '-' }}</div>
            <div class="caption mt-2">ที่อยู่</div>
            <div style="font-weight: bold">
              {{ user.address ? user.address.replace(',.', ' ') : '-' }}
            </div>
            <div class="caption mt-2">อีเมล์</div>
            <div style="font-weight: bold">{{ user.email ? user.email : '-' }}</div>
            <div class="caption mt-2">เบอร์โทรศัพท์</div>
            <div style="font-weight: bold">{{ user.phoneno ? user.phoneno : '-' }}</div>
          </div>
        </v-flex>
        <v-flex xs12 class="pl-3 pr-3 pt-0 pb-2">
          <div>
            <label class="caption">{{ $t('Dealer Status') }}</label>
            <div
              v-if="true"
              class="form-control pa-1"
              :class="{ 'has-error': errors.has('Dealer Status') }"
            >
              <multiselect
                :data-vv-as="$t('Dealer Status')"
                v-validate="'required'"
                name="Dealer Status"
                :searchable="false"
                :loading="saveloading"
                :disabled="saveloading"
                color="primary"
                @input="onChangeStatus"
                v-model="toauser.dealer_status"
                :options="['none', 'waiting for approval', 'approve']"
                placeholder="Dealer Status"
              >
                <template slot="singleLabel" slot-scope="props">
                  <div :style="`color: ${toatstatuscolor(props.option)}`" class="option__desc">
                    {{ props.option }}
                  </div>
                </template>
                <template slot="option" slot-scope="props">
                  <div :style="`color: ${toatstatuscolor(props.option)}`" class="option__desc">
                    {{ props.option }}
                  </div>
                </template>
              </multiselect>
              <span class="text-error" v-if="errors.has('Dealer Status')">{{
                errors.first('Dealer Status')
              }}</span>
            </div>
            <p v-else style="word-break: break-word">
              {{ user.dealer_status ? user.dealer_status : '-' }}
            </p>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <v-divider class="my-2"></v-divider>
    <template v-if="selectedBot.theme == 'toa'">
      <div class="mr-2 mt-2 text-xs-right">
        <v-icon
          v-show="!toauserEdit"
          @click="clickToaEdit"
          style="cursor: pointer"
          small
          color="primary"
          >fas fa-pencil-alt</v-icon
        >
      </div>
      <v-layout row wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-0 pb-2">
          <label class="caption">{{ $t('Merchant ID') }}</label>
          <div
            v-if="toauserEdit"
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('MerchantID') }"
          >
            <input
              v-validate="'required'"
              name="MerchantID"
              placeholder="Merchant ID"
              type="text"
              v-model="toauser.paysolutionmerchantid"
            />
            <span class="text-error" v-if="errors.has('MerchantID')">{{
              errors.first('MerchantID')
            }}</span>
          </div>
          <p v-else>{{ user.paysolutionmerchantid ? user.paysolutionmerchantid : '-' }}</p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-0 pb-2">
          <label class="caption">{{ $t('Store ID') }}</label>
          <div
            v-if="toauserEdit"
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('StoreID') }"
          >
            <input
              v-validate="'required'"
              name="StoreID"
              v-if="toauserEdit"
              placeholder="Store ID"
              type="text"
              v-model="toauser.shop_id"
            />
            <span class="text-error" v-if="errors.has('StoreID')">{{
              errors.first('StoreID')
            }}</span>
          </div>
          <p v-else>{{ user.shop_id ? user.shop_id : '-' }}</p>
        </v-flex>

        <v-flex xs12 class="pl-3 pr-3 pt-0 pb-2">
          <label class="caption">{{ $t('Fillgood Token') }}</label>
          <div
            v-if="toauserEdit"
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('Fillgood Token') }"
          >
            <input
              v-validate="'required'"
              v-if="toauserEdit"
              name="Fillgood Token"
              placeholder="Fillgood Token"
              type="text"
              v-model="toauser.fillgood_token"
            />
            <span class="text-error" v-if="errors.has('Fillgood Token')">{{
              errors.first('Fillgood Token')
            }}</span>
          </div>
          <p v-else style="word-break: break-word">
            {{ user.fillgood_token ? user.fillgood_token : '-' }}
          </p>
        </v-flex>
        <v-flex xs12>
          <div class="text-xs-center" v-if="toauserEdit | showSave">
            <v-btn dense @click="canceltoa" outline color="grey">{{ $t('cancel') }}</v-btn>
            <v-btn dense @click="saveToa" :loading="saveloading" depressed color="primary">{{
              $t('save')
            }}</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import multiselect from 'vue-multiselect'
import api from '@/api'
export default {
  props: ['user'],
  data() {
    return {
      // user: this.value,
      toauserEdit: false,
      toauser: {},
      saveloading: false,
      tempstatus: '',
      showSave: false,
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
  },
  components: {
    multiselect,
  },
  mounted() {
    this.toauser = {
      paysolutionmerchantid: this.user.paysolutionmerchantid ? this.user.paysolutionmerchantid : '',
      fillgood_token: this.user.fillgood_token ? this.user.fillgood_token : '',
      shop_id: this.user.shop_id ? this.user.shop_id : '',
      dealer_status: this.user.dealer_status ? this.user.dealer_status : '',
    }

    this.tempstatus = this.user.dealer_status
      ? JSON.parse(JSON.stringify(this.user.dealer_status))
      : ''
  },
  methods: {
    onChangeStatus(val) {
      if (val == 'approve') {
        if (val != this.tempstatus) {
          this.toauserEdit = true
        } else this.showSave = false
      } else {
        this.toauserEdit = false
        if (this.tempstatus != val) {
          this.showSave = true
        } else this.showSave = false
      }
    },
    toatstatuscolor(status) {
      if (status == 'waiting for approval') return '#fb8c00'
      else if (status == 'approve') return 'green'
      else return 'rgb(201 201 201)'
    },
    close() {
      this.$emit('close')
    },
    clickToaEdit() {
      this.toauserEdit = true
    },
    async canceltoa() {
      await this.$validator.pause()
      this.$nextTick(() => {
        this.toauser = {
          paysolutionmerchantid: '',
          fillgood_token: '',
          shop_id: '',
          dealer_status: '',
        }
        this.dealer_status = this.tempstatus
        this.showSave = false
        this.toauserEdit = false
      })
    },
    saveToa() {
      var vm = this
      vm.$validator.validate().then((result) => {
        console.log(result)
        if (!result) {
          // do stuff if not valid.
          return false
        } else {
          this.saveloading = true
          var data = {
            userid: this.user.id,
            pageid: this.selectedBot.pageid,
            shop_id: this.toauser.shop_id,
            fillgood_token: this.toauser.fillgood_token,
            paysolutionmerchantid: this.toauser.paysolutionmerchantid,
            dealer_status: this.toauser.dealer_status,
          }

          api.toadealerupdatetoken(data, (err, response) => {
            this.saveloading = false
            if (response.responsecode == 200) {
              // Object.assign(this.user, {
              //   shop_id: this.toauser.shop_id,
              //   fillgood_token: this.toauser.fillgood_token,
              //   paysolutionmerchantid: this.toauser.paysolutionmerchantid,
              //   dealer_status: this.toauser.dealer_status,
              // })
              Object.assign(this.user, {
                shop_id: this.toauser.shop_id,
                fillgood_token: this.toauser.fillgood_token,
                paysolutionmerchantid: this.toauser.paysolutionmerchantid,
                dealer_status: this.toauser.dealer_status,
              })
              this.$emit('updateUserToa', this.user)
              this.toauserEdit = false
              this.showSave = false
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/dashboard/ToaApprove.vue